import imgEnchante101 from "./img-enchante10 (1).webp";
import imgEnchante102 from "./img-enchante10 (2).webp";
import imgEnchante103 from "./img-enchante10 (3).webp";

const imgEnchante10 = [imgEnchante101, imgEnchante102, imgEnchante103];

export default imgEnchante10;
